// @flow
import React, { Component } from 'react';
import BannerCardList from 'components/common/BannerCardList/BannerCardList';
import type { State } from 'store';
import { BanneringActions } from 'store/actionCreators';
import type { BannerItem } from 'store/modules/bannering';
import { connect } from 'react-redux';
import throttle from 'lodash/throttle';
import { getScrollBottom, preventStickBottom } from 'lib/common';

type OwnProps = {
  sort: string,
  category: string,
};

type Props = OwnProps & {
  banners: ?(BannerItem[]),
  prefetched: ?(BannerItem[]),
  prefetching: boolean,
  loading: boolean,
  width: number,
  hasEnded: boolean,
  shouldCancel: boolean,
};

class BanneringBannerCards extends Component<Props> {
  prevCursor: ?string = null;

  prefetch = async () => {
    const { banners, prefetching, loading, category, sort } = this.props;
    if (!banners || banners.length === 0 || prefetching || loading) return;
    const lastId = banners[banners.length - 1].id;
    if (this.props.prefetched) {
      BanneringActions.revealPrefetched('recent');
      await Promise.resolve(); // next tick
    }
    if (lastId === this.prevCursor) return;
    this.prevCursor = lastId;
    try {
      await BanneringActions.prefetchRecentBanners(lastId, category, sort);
    } catch (e) {
      console.log(e);
    }
    preventStickBottom();
    this.onScroll();
  };

  onScroll = throttle(() => {
    const scrollBottom = getScrollBottom();
    if (scrollBottom > 1000) return;
    this.prefetch();
  }, 250);

  initialize = async () => {
    const { banners, shouldCancel, category, sort } = this.props;
    try {
      if (banners && banners.length > 0) {
        // do not fetch banner data when already exists
        return;
      }
      if (!shouldCancel) {
        await BanneringActions.getRecentBanners('', category, sort);
      }
      this.prefetch();
    } catch (e) {
      console.log(e);
    }
  };

  listenScroll = () => {
    window.addEventListener('scroll', this.onScroll);
  };

  unlistenScroll = () => {
    window.removeEventListener('scroll', this.onScroll);
  };

  listenSort = async () => {
    const { category, sort } = this.props;
    await BanneringActions.getRecentBanners('', category, sort);
    this.prefetch();
  };

  componentDidMount() {
    this.initialize();
    this.listenScroll();
  }

  componentWillUnmount() {
    this.unlistenScroll();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sort !== this.props.sort) {
      this.listenSort();
    }
  }

  render() {
    return (
      <BannerCardList
        banners={this.props.banners}
        loading={this.props.loading}
        prefetching={
          (this.props.prefetched && this.props.prefetched.length > 0) || this.props.prefetching
        }
        width={this.props.width}
        hasEnded={this.props.hasEnded}
        isTrending={false}
      />
    );
  }
}

const mapStateToProps = ({ bannering, pender, base, common }: State) => ({
  banners: bannering.recent.banners,
  prefetched: bannering.recent.prefetched,
  prefetching: pender.pending['bannering/PREFETCH'],
  loading: pender.pending['bannering/GET_RECENT_POSTS'],
  width: base.windowWidth,
  hasEnded: bannering.recent.end,
  shouldCancel: common.ssr && !common.router.altered,
});

export default connect(mapStateToProps, () => ({}))(BanneringBannerCards);



// WEBPACK FOOTER //
// ./src/containers/list/BanneringBannerCards.js